import React, { createContext, useContext } from "react"

import { useAppContext } from "@contexts/app_context"

const AiEvalMocksPageContext = createContext({
  translate: (key: string) => key
})

export function AiEvalMocksPageContextProvider(props: {
  children: JSX.Element | JSX.Element[]
}) {
  const { translate } = useAppContext()
  return (
    <AiEvalMocksPageContext.Provider value={{ translate }}>
      {props.children}
    </AiEvalMocksPageContext.Provider>
  )
}

export function useAiEvalMocksPageContext() {
  return useContext(AiEvalMocksPageContext)
}
